import { format, parseISO } from 'date-fns';
export type VideoProgress = {
  firstWatched: string;
  lastWatched: string;
  played: number;
  playedSeconds: number;
  url: string;
  userId: string;
  views: number;
};

export type BackendVideoProgress = {
  first_watched: string;
  last_watched: string;
  played: number;
  played_seconds: number;
  url: string;
  user_id: string;
  views: number;
};

export const mapBackendVideoProgressToVideoProgress = (
  backend: BackendVideoProgress
): VideoProgress => ({
  firstWatched: format(parseISO(backend.first_watched), 'dd/MM/yyyy'),
  lastWatched: format(parseISO(backend.last_watched), 'dd/MM/yyyy'),
  played: backend.played,
  playedSeconds: backend.played_seconds,
  url: backend.url,
  userId: backend.user_id,
  views: backend.views,
});

export const getGroupVideoProgressMapper = (response: any): VideoProgress[] =>
  response.data.map(mapBackendVideoProgressToVideoProgress);

export const getStudentVideoProgressMapper = (response: any): VideoProgress =>
  mapBackendVideoProgressToVideoProgress(response.data as BackendVideoProgress);
